import { FC } from 'react';
import { BoxProps } from '@urbaninfrastructure/react-ui-kit';
import { Box, Text, Image } from '../../components';
import { emailBusinessRegisterWelcomeQuery_sanitySettings } from '../../core-types';
import { getFaviconKey } from '../../lib/util';
import { useSystemConfig } from '../../lib/system-config-context';
import { BlockContent } from '../../components/BlockContent';
import { urbansharingAssetsPath } from '../../lib/constants';
import { useStaticDataSystem } from '../../lib/core/staticDataQuery';

export const EmailHeader = ({
  sanitySettings,
  companyName
}: {
  sanitySettings: emailBusinessRegisterWelcomeQuery_sanitySettings;
  companyName: string | null;
}) => {
  const systemConfig = useSystemConfig();
  const staticDataSystem = useStaticDataSystem();
  const faviconKey = getFaviconKey(systemConfig, staticDataSystem);

  let src;

  if (faviconKey) {
    src =
      urbansharingAssetsPath +
      `/v1/favicons/public-web/${faviconKey}/android-chrome-256x256.png`;
  }

  const title = sanitySettings.title;

  let showName;

  if (title) {
    showName = true;
  }

  const imageWidth = 100;

  return (
    <Box textAlign="center">
      {src && (
        <Box mb="xxs" color="primaryText" width={imageWidth} mx="auto">
          <Image width={imageWidth} src={src} />
        </Box>
      )}
      {showName && (
        <Text as="p" color="primaryText" typoStyle="xs">
          {title} {companyName && `| ${companyName}`}
        </Text>
      )}
    </Box>
  );
};

export const EmailRenderLayout: FC<{
  textAlign?: BoxProps['textAlign'];
  companyName: string | null;
  sanitySettings: emailBusinessRegisterWelcomeQuery_sanitySettings;
}> = ({ children, textAlign, companyName, sanitySettings }) => {
  return (
    <Box textAlign={textAlign} m="sm">
      <EmailHeader companyName={companyName} sanitySettings={sanitySettings} />
      {children}
      {sanitySettings.footer && sanitySettings.footer.aboutOperator && (
        <Text fontWeight="normal" textAlign="center" small mute>
          <BlockContent blocks={sanitySettings.footer.aboutOperator} />
        </Text>
      )}
    </Box>
  );
};
